import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { ApiService } from '../../api/api.service';

@Injectable({
  providedIn: 'root',
})
export class HeaderService {
  private headersCache$: Observable<any> | null = null;

  constructor(private apiService: ApiService) {}

  getHeaders() {
    const endpoint = 'menu/header';
    return this.apiService.get(endpoint);
  }

  getNotifications(customerId: number, page: number = 1) {
    const endpoint = `customer/notifications/${customerId}`;
    return this.apiService.get(endpoint, { page: page }, true);
  }
}
